import { ProgressSpinner } from "primereact/progressspinner";

const Loader = () => {
  return (
    <div>
      <div className="absolute inset-0 bg-gray-100 opacity-50 flex flex-col items-center justify-center">
        <ProgressSpinner
          style={{ width: "50px", height: "50px" }}
          strokeWidth="2"
          fill="var(--surface-ground)"
          animationDuration=".5s"
        />
      </div>
    </div>
  );
};

export default Loader;
